import React from 'react'

// styles
import { WrapLoading } from './index.styles'

//image
import IcClock from '../../../assets/images/IcClock'


const Loading = () => {
    return (
        <WrapLoading>
            <div className="wrap-overlay">
                <div className="wrap-notify">
                    <IcClock />
                    <span>Đang chờ xử lý...</span>
                </div>
            </div>
        </WrapLoading>
    )
}

export default Loading
